import { combineReducers } from 'redux'

import token from './token'

export default combineReducers({
  token,
})
